import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import dir from './dir.js'
import labelPosition from './labelPosition.js'
import skin from './skin.js'
import theme from './theme.js'

export default contract({
  dir: array([
    dir
  ]),
  labelPosition: array([
    labelPosition
  ]),
  skin: array([
    skin
  ]),
  theme: array([
    theme
  ])
})